/* global axios */
import ApiClient from './ApiClient';

// Backs Relatórios > Campanhas — fetches a short-lived, single-use SSO URL into
// reports-metaads (see Api::V2::Accounts::CampaignReportsController#sso_url).
class CampaignReportsAPI extends ApiClient {
  constructor() {
    super('campaign_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  ssoUrl() {
    return axios.get(`${this.url}/sso_url`);
  }
}

export default new CampaignReportsAPI();
